interface AvailabilityIndicatorProps {
  type: 'none' | 'line' | 'segmented';
  thickness: number;
  colorBase: string;
  colorProgress: string;
  progress: number;
  label?: string;
}

export function AvailabilityIndicator({
  type,
  thickness,
  colorBase,
  colorProgress,
  progress,
  label
}: AvailabilityIndicatorProps) {
  if (type === 'none') return null;

  return (
    <div className="space-y-2">
      {label && (
        <p className="text-xs text-muted-foreground text-center">{label}</p>
      )}
      
      {type === 'line' && (
        <div
          className="w-full rounded-full overflow-hidden"
          style={{
            height: `${thickness}px`,
            backgroundColor: colorBase
          }}
        >
          <div
            className="h-full transition-all duration-300 ease-out"
            style={{
              width: `${progress}%`,
              backgroundColor: colorProgress
            }}
          />
        </div>
      )}

      {type === 'segmented' && (
        <div className="flex gap-2">
          {[...Array(6)].map((_, index) => {
            const segmentProgress = Math.max(0, Math.min(100, (progress - index * (100 / 6)) * 6));
            return (
              <div
                key={index}
                className="flex-1 rounded-full overflow-hidden transition-all duration-300"
                style={{
                  height: '8px',
                  backgroundColor: segmentProgress > 0 ? colorProgress : colorBase,
                  opacity: segmentProgress > 0 ? segmentProgress / 100 : 1
                }}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
